import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation('common');

  const services = [
    {
      icon: 'ri-paint-brush-line',
      image: 'https://public.readdy.ai/ai/img_res/514ab1c56c94ef946b800b5a44bf7960.jpg',
      nameKey: 'interiorDesign',
    },
    {
      icon: 'ri-sparkling-2-line',
      image: 'https://readdy.ai/api/search-image?query=professional%20cleaning%20service%20spotless%20modern%20home%20pristine%20white%20surfaces%20gleaming%20floors%20sparkling%20clean%20interior%20fresh%20and%20organized%20living%20space%20immaculate%20house%20cleaning%20results%20professional%20housekeeping&width=800&height=600&seq=service-cleaning-001&orientation=landscape',
      nameKey: 'cleaning',
    },
    {
      icon: 'ri-tools-line',
      image: 'https://readdy.ai/api/search-image?query=home%20maintenance%20and%20repair%20professional%20handyman%20service%20fixing%20household%20items%20tool%20kit%20organized%20workspace%20quality%20home%20improvement%20skilled%20technician%20working%20reliable%20maintenance%20solutions&width=800&height=600&seq=service-maintenance-001&orientation=landscape',
      nameKey: 'maintenance',
    },
    {
      icon: 'ri-home-gear-line',
      image: 'https://readdy.ai/api/search-image?query=home%20renovation%20transformation%20modern%20house%20remodeling%20construction%20progress%20beautiful%20upgraded%20interior%20space%20contemporary%20home%20improvement%20quality%20renovation%20work%20professional%20contractors%20stylish%20redesign&width=800&height=600&seq=service-renovation-001&orientation=landscape',
      nameKey: 'renovation',
    },
  ];

  const handleLearnMore = () => {
    const bookingSection = document.getElementById('booking');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl text-[#2B2B2B] mb-4">
            {t('services.title')}
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl cursor-pointer"
              onClick={handleLearnMore}
            >
              <div className="relative h-[400px]">
                <img
                  src={service.image}
                  alt={t(`services.${service.nameKey}`)}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl mb-4">
                    <i className={`${service.icon} text-2xl`}></i>
                  </div>
                  <h3 className="text-xl font-semibold mb-2">
                    {t(`services.${service.nameKey}`)}
                  </h3>
                  <div className="flex items-center text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                    <span className="whitespace-nowrap">{t('services.learnMore')}</span>
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
